import {Client} from '../client';
import * as types from '../types';
import * as mathjs from 'mathjs';

/**
 * Utils for the MCPS SDK
 * @category Modules
 * @since v0.17
 */
export class Utils {
    /** @hidden */
    private client: Client;
    /** @hidden */
    private mathConfig = {
        number: 'BigNumber', // Choose 'number' (default), 'BigNumber', or 'Fraction'
        precision: 64, // 64 by default, only applicable for BigNumbers
    };
    /** @hidden */
    private math: Partial<mathjs.MathJsStatic>;

    /** @hidden */
    constructor(client: Client) {
        this.client = client;
        this.math = mathjs.create(mathjs.all, this.mathConfig);
    }

}
